var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dealData)?_c('div',{staticClass:"relative"},[_c('ReportPreviewToolbar'),_c('Report',_vm._b({},'Report',_vm.previewReportData,false)),(_vm.isErrorNetworkModalDisplayed && !_vm.isUnstableConnectionModalDisplayed)?_c('ErrorNetworkModal'):_vm._e(),(_vm.isUnstableConnectionModalDisplayed)?_c('ErrorUnstableConnectionModal'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }